import React, { useEffect, useState } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate } from "react-router-dom";
import { useQuiz } from "../../pages/quiz/hooks";
import Button from "../Button";
import callApi from "../../utils/api";
import { IR_COURSE_MAPPING } from "../../store/quiz/quizBaseApi";
import { getById } from "../../store/course/courseBaseApi";
import { ScreenTypes } from "../../store/quiz/quizSlice";
import { useStudy } from "../../pages/study/hooks";
import { APPLICATION_NAME, nowISO } from "../../utils";
import { promoteStudent } from "../../store/student/studentBaseApi";

export const QuizResultAction = ({ onComplete, onFail, mandatePassing }) => {
  const { type, gradingResult } = useQuiz();

  if (!type) return <Default />;

  if (mandatePassing && !gradingResult.passed)
    return <Default onFail={onFail} />;

  if (type === "diagnostic-test") return <DiagnosticTest />;

  if (type === "diagnostic-test-v2")
    return <DiagnosticTestV2 onComplete={onComplete} />;

  if (type === "assessment") return <Assessment onComplete={onComplete} />;
};

const Assessment = ({ onComplete }) => {
  return (
    <div style={styles.retryContainer}>
      <Button
        onClick={onComplete}
        variant="contained"
        size="large"
        placeholder={"Continue"}
        sx={{ background: "var(--mui-palette-primary-button)" }}
      />
    </div>
  );
};

const DiagnosticTestV2 = ({ onComplete }) => {
  return (
    <div style={styles.retryContainer}>
      <Button
        onClick={onComplete}
        icon={<RefreshIcon />}
        variant="contained"
        size="large"
        placeholder={"Continue"}
        sx={{ background: "var(--mui-palette-primary-button)" }}
      />
    </div>
  );
};

const DiagnosticTest = () => {
  const { gradingResult, setCourseAssigned, setNextCourseId } = useQuiz();
  const { irLevelMapping, updateProfile, profile, assignCourse } = useStudy();
  const [courseId, setCourseId] = useState(null);

  const navigate = useNavigate();

  const navigateToCourse = () => navigate(`/study/course/${courseId}`);

  const loadCourse = async (id) => {
    let { data } = await getById({ id });
    return data;
  };

  useEffect(() => {
    if (!courseId) return;

    loadCourse(courseId).then(async (course) => {
      setCourseAssigned(course);

      let now = nowISO();
      let _course = {
        courseId: course.id,
        courseName: course.courseName,
        courseCode: course.code,
        dateEnrolled: now,
        assignedBy: profile.id,
        assignedDate: now,
        assignedMethod: "",
        currentStatus: "ASSIGNED",
      };

      assignCourse({
        body: {
          application: APPLICATION_NAME,
          assigneeRole: "student",
          assignedUserId: profile.id,
          courses: [_course],
        },
      });
    });
  }, [courseId]);

  useEffect(() => {
    //  Add logic to assign a course id via API call.

    if (!gradingResult.grade) return;

    (async () => {
      let courseMappings = await callApi().asyncFetchContent(IR_COURSE_MAPPING);
      let { levelAssignment } = irLevelMapping;

      if (levelAssignment && levelAssignment.length) {
        let mapping = levelAssignment.find(
          (e) => e.grade == gradingResult.grade,
        );
        //  If mapping found, get the course id.
        if (mapping && mapping.level) {
          let courseInd = courseMappings.findIndex(
            (e) => e.level == mapping.level,
          );
          if (courseInd != -1) {
            let _courseId = courseMappings[courseInd]["irCourseId"];

            setCourseId(_courseId);

            if (courseMappings[courseInd + 1]) {
              console.info("Found next course Id");
              setNextCourseId(courseMappings[courseInd + 1]["irCourseId"]);
            }
          }

          let { level } = mapping;
          updateProfile({
            // body: { gradeLevel: level },
            body: { gradeLevel: level, diagnosticTest: true },
            role: "students", //   Hardcoding the role as of now
            id: profile.id,
          });
        }
      }
    })();
  }, [gradingResult]);

  return (
    <div style={styles.retryContainer}>
      <Button
        onClick={() => navigateToCourse()}
        icon={<RefreshIcon />}
        variant="contained"
        size="large"
        disabled
        placeholder={
          !courseId
            ? "Please wait..."
            : "Proceed to course" && profile?.irStatus !== "ONBOARD"
              ? "Teacher Approval Pending"
              : ""
        }
        sx={{ background: "var(--mui-palette-primary-button)" }}
      />
    </div>
  );
};

const Default = ({ onFail }) => {
  const { setScreen } = useQuiz();

  const action = () => {
    if (onFail && typeof onFail === "function") {
      onFail();
    }
    setScreen(ScreenTypes.QuizDetail);
  };

  return (
    <div style={styles.retryContainer}>
      <Button
        onClick={action}
        icon={<RefreshIcon />}
        variant="contained"
        size="large"
        placeholder={"Retry assessment"}
        sx={{ background: "var(--mui-palette-primary-button)" }}
      />
    </div>
  );
};

const styles = {
  retryContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "40px",
  },
};
